import InternalStakeholderAvailabilityEvent from "../event/InternalStakeholderAvailabilityEvent";
import InternalStakeholderDefinition from "./InternalStakeholderDefinition";
import InternalStakeholdersConfig from "./InternalStakeholdersConfig";

export default class InternalStakeholdersModel {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher
     * @param {InternalStakeholdersConfig} internalStakeholdersConfig 
     */
    constructor(dispatcher, internalStakeholdersConfig) {
        this._dispatcher = dispatcher;
        this._internalStakeholdersConfig = internalStakeholdersConfig;

        this._activeInternalStakeholders = [];
        this._contentByInternalStakeholderId = {};
        this._contentPlayerByInternalStakeholderId = {};
    }

    setContentForInternalStakeholderId(internalStakeholderId, content) {
        this._contentByInternalStakeholderId[internalStakeholderId] = content;
    }

    getContentForInternalStakeholderId(internalStakeholderId) {
        return this._contentByInternalStakeholderId[internalStakeholderId];
    }

    setContentPlayerForInternalStakeholderId(internalStakeholderId, contentPlayer) {
        this._contentPlayerByInternalStakeholderId[internalStakeholderId] = contentPlayer;
    }

    getContentPlayerForInternalStakeholderId(internalStakeholderId) {
        return this._contentPlayerByInternalStakeholderId[internalStakeholderId];
    }

    /**
     * @param {InternalStakeholderDefinition} internalStakeholder 
     */
    activateInternalStakeholder(internalStakeholder) {
        this._activeInternalStakeholders.push(internalStakeholder);

        const internalStakeholderAvailabilityEvent = new InternalStakeholderAvailabilityEvent(InternalStakeholderAvailabilityEvent.INTERNAL_STAKEHOLDER_AVAILABLE, internalStakeholder);
        this._dispatcher.dispatch(internalStakeholderAvailabilityEvent.type, { data: internalStakeholderAvailabilityEvent });
    }

    /**
     * @param {InternalStakeholderDefinition} internalStakeholder 
     */
    deactivateInternalStakeholder(internalStakeholder) {
        const activeInternalStakeholderIndex = this._activeInternalStakeholders.indexOf(internalStakeholder);
        this._activeInternalStakeholders.splice(activeInternalStakeholderIndex, 1);

        const internalStakeholderAvailabilityEvent = new InternalStakeholderAvailabilityEvent(InternalStakeholderAvailabilityEvent.INTERNAL_STAKEHOLDER_UNAVAILABLE, internalStakeholder);
        this._dispatcher.dispatch(internalStakeholderAvailabilityEvent.type, { data: internalStakeholderAvailabilityEvent });
    }

    /**
     * @param {InternalStakeholderDefinition} internalStakeholder 
     * @return {boolean}
     */
    internalStakeholderIsActive(internalStakeholder) {
        return this._activeInternalStakeholders.indexOf(internalStakeholder) > -1;
    }

    getInternalStakeholderById(internalStakeholderId) {
        return this.internalStakeholders.find(i => i.id === internalStakeholderId);
    }

    get activeInternalStakeholders() {
        return this._activeInternalStakeholders;
    }

    get internalStakeholders() {
        return this._internalStakeholdersConfig.internalStakeholders;
    }

    get internalStakeholderIds() {
        return this.internalStakeholders.map(i => i.id);
    }
}